import request from '../request'
export const getlist = (ad) => request({ method: 'POST', url: `/api/hotel/hotels?ad=${ad}` });
export const getregister = (data) => request({ method: 'post', url: '/api/hotel/register', data });
export const getlogin = (data) => request({ method: 'post', url: '/api/hotel/login', data });